/*
  Oz BBQ AAA: search results extras (aaa-cart.js runs the filters, sort,
  flat "Show more" and compare). This adds:
  - "Show all" on each grouped result set (cards are already in the page)
  - "Fuel and parts" shelf tabs (wood / covers / spares) and "Show more":
    reveals the add-ons already drawn, then pulls later 24-a-page results and
    keeps only add-ons not yet on screen, always stopping on a whole row
    while more remain
  - the flat "Viewing 1-48 of N" line after each Show more
  - the range-chip arrow and edge fade (tablet / phone), and the same
    arrow and fade on the shelf tabs and Smokers price bands
  - Smokers price bands (Under $500 / $500 to $999 / $1,000 and up): filters
    the group's own cards in place
  Delegated, so it survives the section being re-rendered by a filter change.
*/
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncChips(host) {
    var sc = host.querySelector('[data-cx-scroller]');
    if (!sc) return;
    var ul = sc.querySelector('ul');
    if (!ul) return;
    var over = ul.scrollWidth - ul.clientWidth > 4;
    var end = !over || ul.scrollWidth - ul.clientWidth - ul.scrollLeft <= 4;
    sc.classList.toggle('is-end', end);
    var btn = sc.querySelector('[data-cxs-chips-next]');
    if (btn) btn.hidden = !over;
  }
  function syncHs(box) {
    var tr = box.querySelector('[data-cxs-hs-track]');
    if (!tr) return;
    var over = tr.scrollWidth - tr.clientWidth > 4;
    box.classList.toggle('is-end', !over || tr.scrollWidth - tr.clientWidth - tr.scrollLeft <= 4);
    var btn = box.querySelector('[data-cxs-hs-next]');
    if (btn) btn.hidden = !over;
  }
  // Compare tile: fills the empty cells of its group's last row at the
  // column count on screen, and hides on a whole row.
  function syncSplit() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cxs-fill]'), function (tile) {
      var grid = tile.parentNode;
      var n = Array.prototype.filter.call(grid.children, function (li) { return li !== tile && !li.classList.contains('cxs-adv') && getComputedStyle(li).display !== 'none'; }).length;
      var c = colsOf(grid);
      var k = n % c ? c - (n % c) : 0;
      tile.classList.toggle('is-fill-on', k > 0 && c > 2);
      tile.classList.toggle('is-wide', k >= 2);
      tile.style.gridColumn = k > 0 ? 'span ' + k : '';
    });
  }
  function syncAll() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cx-search]'), syncChips);
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cxs-hs]'), syncHs);
    syncSplit();
  }

  doc.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cxs-chips-next]');
    if (c) {
      var ul = c.closest('[data-cx-scroller]').querySelector('ul');
      if (ul) ul.scrollBy({ left: ul.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    var h = e.target.closest('[data-cxs-hs-next]');
    if (h) {
      var tr = h.closest('[data-cxs-hs]').querySelector('[data-cxs-hs-track]');
      if (tr) tr.scrollBy({ left: tr.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' });
    }
  });
  doc.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.closest && t.closest('[data-cx-scroller]')) window.requestAnimationFrame(function () { syncChips(t.closest('[data-cx-search]')); });
    if (t.matches('[data-cxs-hs-track]')) window.requestAnimationFrame(function () { syncHs(t.closest('[data-cxs-hs]')); });
  }, true);
  window.addEventListener('resize', syncAll);

  // Flat results: "Viewing 1-48 of N" follows aaa-cart.js's seen count.
  function recount(host) {
    var nav = host.querySelector('[data-cx-more-wrap]');
    if (!nav) return;
    var to = nav.querySelector('[data-cxs-to]');
    var seen = parseInt((nav.querySelector('[data-cx-seen]') || {}).textContent, 10) || 0;
    if (to && seen) to.textContent = seen;
  }

  // Columns the grid is showing right now (4 / 3 / 2).
  function colsOf(grid) {
    return getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
  }
  function shownItems(grid) {
    return Array.prototype.filter.call(grid.children, function (li) { return li.offsetParent !== null || getComputedStyle(li).display !== 'none'; });
  }
  function focusFirst(li) {
    var a = li && li.querySelector('a[href]:not([tabindex="-1"]), button');
    if (a) a.focus({ preventScroll: true });
  }

  // "Show all N smokers": the rest of the group is already in the page.
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cxs-all]');
    if (!btn) return;
    var sec = btn.closest('.cxs-group');
    var grid = sec && sec.querySelector('[data-cx-grid]');
    if (!grid) return;
    var before = shownItems(grid).length;
    sec.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    btn.closest('.cxs-all').hidden = true;
    var first = grid.children[before];
    if (first) focusFirst(first);
  });

  // Smokers by price: the group already holds every card, so a band just
  // filters it in place. On desktop the group is split (first row beside the
  // filter rail, the rest full width); a band gathers its matches into the
  // top grid and hides the buying guide, and "All" puts every card back.
  doc.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cxs-band]');
    if (!tab || tab.getAttribute('aria-pressed') === 'true') return;
    var host = tab.closest('[data-cx-search]');
    var sec = tab.closest('.cxs-group');
    var grids = host ? host.querySelectorAll('[data-cxs-grid="a"]') : [];
    if (!sec || !grids.length) return;
    var top = grids[0];
    if (!top._cxsOrig) {
      top._cxsOrig = [];
      Array.prototype.forEach.call(grids, function (g) {
        Array.prototype.forEach.call(g.children, function (li) { top._cxsOrig.push([li, g]); });
      });
    }
    Array.prototype.forEach.call(sec.querySelectorAll('[data-cxs-band]'), function (b) { b.setAttribute('aria-pressed', b === tab ? 'true' : 'false'); });
    var band = tab.getAttribute('data-cxs-band');
    var lo = 0, hi = Infinity;
    if (band) { var p = band.split('-'); lo = parseFloat(p[0]) || 0; hi = p[1] ? parseFloat(p[1]) : Infinity; }
    top._cxsOrig.forEach(function (pair) {
      var li = pair[0];
      if (!band) { li.hidden = false; pair[1].appendChild(li); return; }
      if (!li.hasAttribute('data-p') || li.hasAttribute('data-dup')) { li.hidden = true; return; }
      var v = parseFloat(li.getAttribute('data-p'));
      var ok = v >= lo && v <= hi;
      li.hidden = !ok;
      if (ok) top.appendChild(li);
    });
    Array.prototype.forEach.call(grids, function (g) {
      g.classList.toggle('is-banded', !!band);
      var gs = g.closest('.cxs-group');
      if (gs) {
        if (band) gs.classList.add('is-open');
        if (gs.classList.contains('cxs-part-rest')) gs.hidden = !!band;
      }
    });
    var adv = host.querySelector('[data-cxs-adv]');
    if (adv) adv.hidden = !!band;
    syncSplit();
    var live = sec.querySelector('[data-cxs-band-live]');
    if (live) live.textContent = band ? 'Showing ' + tab.getAttribute('data-n') + ' smokers, ' + tab.firstChild.textContent.trim() : 'Showing all ' + tab.getAttribute('data-n') + ' smokers';
  });

  // "Fuel and parts": shelf tabs (All / wood / covers / spares) and "Show
  // more". The first rows come from the server (CSS whole rows); once the
  // shopper touches either control, this owns visibility: only the picked
  // shelf, whole rows while more remain, pulling later 24-a-page results
  // and keeping only add-ons not already on screen.
  function shelfOf(sec) { return sec.getAttribute('data-shelf') || ''; }
  function fits(sec, li) { var s = shelfOf(sec); return !s || li.getAttribute('data-sub') === s; }
  function shelfTotal(sec) {
    var b = sec.querySelector('[data-cxs-shelf][aria-pressed="true"]');
    return b ? parseInt(b.getAttribute('data-n'), 10) || 0 : parseInt(sec.getAttribute('data-total'), 10) || 0;
  }
  function accSync(sec) {
    var grid = sec.querySelector('[data-cxs-acc-grid]');
    var shown = sec.querySelector('[data-cxs-acc-shown]');
    var tot = sec.querySelector('[data-cxs-acc-total]');
    if (!grid) return;
    var n = Array.prototype.filter.call(grid.children, function (li) { return !li.hidden && getComputedStyle(li).display !== 'none'; }).length;
    var total = shelfTotal(sec);
    if (shown) shown.textContent = n;
    if (tot) tot.textContent = total;
    var next = parseInt(sec.getAttribute('data-next'), 10) || 2;
    var pages = parseInt(sec.getAttribute('data-pages'), 10) || 1;
    var held = Array.prototype.some.call(grid.children, function (li) { return li.hidden && fits(sec, li); });
    var done = n >= total || (next > pages && !held && sec.classList.contains('is-open'));
    var wrap = sec.querySelector('.cxs-all--acc');
    if (wrap) wrap.hidden = done;
  }
  function accUrl(page) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', page);
    u.searchParams.delete('section_id');
    var host = doc.querySelector('[data-cx-search]');
    u.searchParams.set('section_id', host.getAttribute('data-section'));
    return u.toString();
  }
  // Show `want` cards of the current shelf (pulling pages as needed), stopping
  // on a whole row while more remain.
  function accShow(sec, want, focusFrom) {
    var grid = sec.querySelector('[data-cxs-acc-grid]');
    var btn = sec.querySelector('[data-cxs-acc-more]');
    var cols = colsOf(grid);
    var pages = parseInt(sec.getAttribute('data-pages'), 10) || 1;
    var total = shelfTotal(sec);
    sec.classList.add('is-open');
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    sec.setAttribute('aria-busy', 'true');
    function matching() { return Array.prototype.filter.call(grid.children, function (li) { return fits(sec, li); }); }
    function finish() {
      var next = parseInt(sec.getAttribute('data-next'), 10) || 2;
      var m = matching();
      var more = next <= pages && m.length < total;
      var limit = Math.min(want, m.length);
      if (more || limit < m.length) limit = Math.max(Math.min(cols, m.length), Math.floor(limit / cols) * cols);
      var k = 0;
      Array.prototype.forEach.call(grid.children, function (li) {
        if (!fits(sec, li)) { li.hidden = true; return; }
        li.hidden = k >= limit; k++;
      });
      if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
      sec.removeAttribute('aria-busy');
      accSync(sec);
      if (focusFrom != null && m[focusFrom]) focusFirst(m[focusFrom]);
    }
    (function pull() {
      var next = parseInt(sec.getAttribute('data-next'), 10) || 2;
      if (matching().length >= want || matching().length >= total || next > pages) { finish(); return; }
      fetch(accUrl(next)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        sec.setAttribute('data-next', next + 1);
        var d = new DOMParser().parseFromString(html, 'text/html');
        Array.prototype.forEach.call(d.querySelectorAll('[data-cx-grid] > li[data-k="acc"]'), function (li) {
          var h = li.getAttribute('data-h');
          if (h && grid.querySelector(':scope > li[data-h="' + h.replace(/"/g, '') + '"]')) return;
          li.className = 'cx-grid__item is-new';
          li.hidden = true;
          grid.appendChild(li);
        });
        pull();
      }).catch(finish);
    })();
  }
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cxs-acc-more]');
    if (!btn || btn.classList.contains('is-busy')) return;
    var sec = btn.closest('[data-cxs-acc]');
    var grid = sec.querySelector('[data-cxs-acc-grid]');
    var before = shownItems(grid).filter(function (li) { return !li.hidden; }).length;
    accShow(sec, before + colsOf(grid) * 3, before);
  });
  doc.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cxs-shelf]');
    if (!tab) return;
    var sec = tab.closest('[data-cxs-acc]');
    if (!sec || tab.getAttribute('aria-pressed') === 'true') return;
    Array.prototype.forEach.call(sec.querySelectorAll('[data-cxs-shelf]'), function (b) { b.setAttribute('aria-pressed', b === tab ? 'true' : 'false'); });
    sec.setAttribute('data-shelf', tab.getAttribute('data-cxs-shelf'));
    var grid = sec.querySelector('[data-cxs-acc-grid]');
    accShow(sec, colsOf(grid) * 2, null);
  });

  // Images: the first row loads eagerly from the server; everything else is
  // lazy. Once the page has loaded and the browser is idle, the rest are
  // fetched in small batches, so a long scroll (or a whole-page capture) never
  // meets an empty tile, and the first paint is never slowed.
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function warm(host) {
    var imgs = Array.prototype.filter.call(host.querySelectorAll('img[loading="lazy"]'), function (i) { return !i.complete || !i.naturalWidth; });
    (function batch() {
      var some = imgs.splice(0, 6);
      if (!some.length) return;
      some.forEach(function (i) { i.loading = 'eager'; });
      idle(batch, { timeout: 800 });
    })();
  }
  function whenLoaded(fn) {
    if (doc.readyState === 'complete') idle(fn, { timeout: 1200 });
    else window.addEventListener('load', function () { idle(fn, { timeout: 1200 }); });
  }

  // ---- Compare state: the tile's button and the floating pill say how many
  // are picked, and nothing offers to open compare until two are. ---------
  function cmpCount() { try { return (JSON.parse(sessionStorage.getItem('cx-compare')) || []).length; } catch (e) { return 0; } }
  function syncCmp() {
    var n = cmpCount();
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cx-fill-cmp]'), function (b) {
      b.disabled = n < 2;
      b.textContent = n >= 2 ? 'Open compare (' + n + ')' : 'Open compare';
    });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cxs-tile-n]'), function (t) {
      t.textContent = n + ' of 3 picked' + (n === 1 ? ': pick one more' : '');
    });
    var fab = doc.querySelector('[data-cxs-fab]');
    if (fab) {
      var b = fab.querySelector('[data-cxs-fab-cmp]');
      var nEl = fab.querySelector('[data-cxs-fab-n]');
      if (b) b.hidden = n < 1;
      if (nEl) nEl.textContent = n;
      if (b) b.setAttribute('aria-label', n >= 2 ? 'Compare ' + n + ' cookers' : n + ' cooker picked to compare. Pick one more');
      fabShow();
    }
  }
  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cx-cmp]')) setTimeout(syncCmp, 0);
  });
  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-cx-cmp-remove], [data-cx-cmp-clear]')) setTimeout(syncCmp, 0);
    var fc = e.target.closest('[data-cxs-fab-cmp]');
    if (fc) {
      if (cmpCount() >= 2) {
        var go = doc.querySelector('[data-cx-cmp-open]');
        if (go) { go.disabled = false; go.click(); }
      } else {
        var t = fc.querySelector('[data-cxs-fab-cmp-t]');
        if (t) { t.textContent = 'Pick 1 more'; setTimeout(function () { t.textContent = 'Compare'; }, 2200); }
      }
    }
  });

  // ---- Floating Filter / Sort / Compare pill (phones and tablets) ----------
  // Shows once the toolbar has scrolled off the top, or while cookers are
  // picked for compare; hides again at the top and over the footer.
  var fabMq = window.matchMedia('(max-width: 989px)');
  var tbGone = false, footIn = false;
  function fabShow() {
    var fab = doc.querySelector('[data-cxs-fab]');
    if (!fab) return;
    var on = fabMq.matches && !footIn && (tbGone || cmpCount() > 0);
    fab.classList.toggle('is-on', on);
    fab.setAttribute('aria-hidden', on ? 'false' : 'true');
    Array.prototype.forEach.call(fab.querySelectorAll('button, select'), function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
  }
  var tbObs = null, ftObs = null;
  function fabInit(host) {
    var tb = host.querySelector('[data-cx-tb]');
    if (!window.IntersectionObserver) return;
    if (tbObs) tbObs.disconnect();
    if (tb) {
      tbObs = new IntersectionObserver(function (es) {
        es.forEach(function (en) { tbGone = !en.isIntersecting && en.boundingClientRect.top < 0; });
        fabShow();
      });
      tbObs.observe(tb);
    }
    if (!ftObs) {
      var ft = doc.querySelector('footer, .aaa-footer, [role="contentinfo"]');
      if (ft) {
        ftObs = new IntersectionObserver(function (es) { es.forEach(function (en) { footIn = en.isIntersecting; }); fabShow(); });
        ftObs.observe(ft);
      }
    }
    syncCmp();
  }
  doc.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-cxs-fab-sort]');
    if (!sel) return;
    var main = doc.querySelector('[data-cx-sort-select]');
    if (!main) return;
    main.value = sel.value;
    main.dispatchEvent(new Event('change', { bubbles: true }));
  });
  if (fabMq.addEventListener) fabMq.addEventListener('change', fabShow);

  function boot() {
    var host = doc.querySelector('[data-cx-search]');
    if (!host) return;
    syncAll();
    fabInit(host);
    Array.prototype.forEach.call(host.querySelectorAll('[data-cxs-acc]'), accSync);
    whenLoaded(function () { warm(host); });
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      var appended = false;
      var rerendered = false;
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList.contains('is-new')) appended = true;
          else if (n.querySelector && (n.matches('[data-cx-sr], .cx-sh') || n.querySelector('.cxs-group, [data-cx-scroller], [data-cx-tb]'))) rerendered = true;
        });
      });
      if (appended) recount(host);
      if (rerendered) { Array.prototype.forEach.call(host.querySelectorAll('[data-cxs-acc]'), accSync); fabInit(host); }
      if (appended || rerendered) { window.requestAnimationFrame(syncAll); idle(function () { warm(host); }, { timeout: 800 }); }
    }).observe(host, { childList: true, subtree: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
